import "../assets/scss/components/_field.scss";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faPencil } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import type { FieldProps } from "../types/components/FieldProps";

export const Field: React.FC<FieldProps> = ({
	label = "Field Label",
	value = "",
	type = "text",
	minLength = 0,
	required = false,
	step = "false",
	onChange = (e: React.InputEvent<HTMLInputElement>) => {},
	onToggleComplete = () => {},
	isEditable = true,
	toggleEditing = false,
	referenceEl = null,
	classes = "",
	autocomplete = "",
	...props
}) => {
	const CheckIsEditable = () => {
		if (!isEditable) return true;
		if (toggleEditing === true && toggledEditing !== true) return true;
		return false;
	};

	const [inputValue, setInputValue] = useState(value);

	const [toggledEditing, setToggledEditing] = useState(false);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<div
			className={`field ${classes} ${toggleEditing ? "toggleable" : ""} ${toggleEditing && toggledEditing ? "toggled" : ""}`}
		>
			{type === "textarea" ? (
				<textarea
					placeholder=" "
					required={required}
					value={inputValue}
					onChange={(e) => {
						setInputValue(e.currentTarget.value);
						onChange(e as React.InputEvent<HTMLTextAreaElement>);
					}}
					aria-label={label}
					ref={referenceEl}
					{...props}
				/>
			) : (
				<input
					type={type}
					minLength={minLength}
					placeholder=" "
					required={required}
					onInput={(e) => {
						setInputValue(e.currentTarget.value);
						onChange(e as React.InputEvent<HTMLInputElement>);
					}}
					autoComplete={autocomplete}
					name={autocomplete}
					disabled={CheckIsEditable()}
					value={inputValue}
					aria-label={label}
					ref={referenceEl}
					step={step}
					{...props}
				/>
			)}
			{toggleEditing && isEditable && (
				<div
					className="edit-button"
					onClick={(e) => {
						setToggledEditing((prev) => !prev);
						onToggleComplete(e);
					}}
				>
					<FontAwesomeIcon icon={toggledEditing ? faCheck : faPencil} />
				</div>
			)}
			<label>{label}</label>
		</div>
	);
};

export default Field;
